import AccountBalanceWalletOutlined from '@mui/icons-material/AccountBalanceWalletOutlined';
import ExitToAppOutlined from '@mui/icons-material/ExitToAppOutlined';
import FileCopyOutlined from '@mui/icons-material/FileCopyOutlined';
import IosShareIcon from '@mui/icons-material/IosShare';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import AccountContainer from './AccountContainer';
import Link from 'next/link';

export interface WalletsDetailsProps {
  currencyIcon: string;
  walletBalance: number;
  walletAddress: string;
  currency: string;
  copied: string;
  isMobile: boolean;
  isThirdWeb: boolean;
  onClickLogout: () => void;
  onClickCopy: (data: string) => void;
  onClickViewWallet: () => void;
  handleExportKey: () => void;
}

const WalletDetails = ({
  copied,
  currency,
  currencyIcon,
  walletAddress,
  walletBalance,
  isMobile,
  isThirdWeb = false,
  onClickLogout,
  onClickCopy,
  onClickViewWallet,
  handleExportKey
}: WalletsDetailsProps) => {
  const theme = useTheme();

  return (
    <Box padding={isMobile ? '8px' : '16px'}>
      {walletAddress && (
        <>
          <AccountContainer
            currency={currency}
            currencyIcon={currencyIcon}
            walletAddress={walletAddress}
            walletBalance={walletBalance}
          />
          <Link href={`https://opensea.io/${walletAddress}`} target="_blank" passHref prefetch>
            <Button
              fullWidth
              sx={{
                marginTop: '24px',
                backgroundColor: theme?.palette?.background?.paper,
                color: theme?.palette?.text?.primary,
                fontWeight: 500,
                fontSize: '16px',
                border: `1px solid ${theme?.ClaimTemplate?.menuButtonBorder}`
              }}
            >
              <AccountBalanceWalletOutlined
                sx={{
                  height: '20px',
                  weight: '20px',
                  marginRight: '6px',
                  cursor: 'pointer'
                }}
              />
              View Wallets
            </Button>
          </Link>
          {isThirdWeb && (
            <Button
              fullWidth
              onClick={handleExportKey}
              sx={{
                marginTop: '24px',
                backgroundColor: theme?.palette?.background?.paper,
                color: theme?.palette?.text?.primary,
                fontWeight: 500,
                fontSize: '16px',
                border: `1px solid ${theme?.ClaimTemplate?.menuButtonBorder}`
              }}
            >
              <IosShareIcon
                sx={{
                  height: '20px',
                  weight: '20px',
                  marginRight: '6px',
                  cursor: 'pointer'
                }}
              />
              Export Private Key
            </Button>
          )}
          <Button
            fullWidth
            onClick={() => onClickCopy(walletAddress)}
            sx={{
              marginTop: '24px',
              backgroundColor: theme?.palette?.background?.paper,
              color: theme?.palette?.text?.primary,
              fontWeight: 500,
              fontSize: '16px',
              border: `1px solid ${theme?.ClaimTemplate?.menuButtonBorder}`
            }}
          >
            <Tooltip open={copied === walletAddress && copied != ''} title="Copied!">
              <FileCopyOutlined
                sx={{
                  height: '20px',
                  weight: '20px',
                  marginRight: '6px',
                  cursor: 'pointer'
                }}
              />
            </Tooltip>
            Copy Wallet Address
          </Button>
          <Button
            fullWidth
            onClick={onClickLogout}
            sx={{
              marginTop: '24px',
              backgroundColor: theme?.palette?.background?.paper,
              color: theme?.palette?.text?.primary,
              fontWeight: 500,
              fontSize: '16px',
              border: `1px solid ${theme?.ClaimTemplate?.menuButtonBorder}`
            }}
          >
            <Tooltip open={false} title="Copied!">
              <ExitToAppOutlined
                sx={{
                  height: '20px',
                  weight: '20px',
                  marginRight: '6px',
                  cursor: 'pointer'
                }}
              />
            </Tooltip>
            Log Out
          </Button>
        </>
      )}
    </Box>
  );
};

export default WalletDetails;
